import { render, staticRenderFns } from "./magazine-grid-with-news-items.vue?vue&type=template&id=06c171aa&"
var script = {}
import style0 from "./magazine-grid-with-news-items.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports